module.exports = __webpack_public_path__ + "d6693eab9ba6b258daf31f6e2f2c3201.svg";